import { routeConfig } from "./config";

const generatePath = (path, params = {}) => {
  return path.replace(/:(\w+)/g, (_, key) => params[key] || "");
};

export const getRoutePath = (route, params = {}) => {
  if (typeof route === "string") {
    const [section, feature, action] = route.split(".");
    const config = routeConfig[section]?.[feature];

    if (!config) return "/";

    const basePath = config.path;
    const childPath = action ? config.children?.[action]?.path : "";

    return generatePath(
      `${basePath}${childPath ? `/${childPath}` : ""}`,
      params
    );
  }
  return "/";
};

export const paths = {
  public: {
    login: () => getRoutePath("public.login"),
  },
  private: {
    dashboardHome: () => getRoutePath("private.dashboardHome"),
    business: {
      list: () => getRoutePath("private.business.list"),
      create: () => getRoutePath("private.business.create"),
      edit: (businessId) =>
        getRoutePath("private.business.edit", { businessId }),
      import: () => getRoutePath("private.business.import"),
      geoImport: () => getRoutePath("private.business.geoImport"),
    },
    geo: {
      import: () => getRoutePath("private.geoAdmin.import"),
      countries: () => getRoutePath("private.geoAdmin.countries"),
      regions: () => getRoutePath("private.geoAdmin.regions"),
      cityRegions: () => getRoutePath("private.geoAdmin.cityRegions"),
      cities: () => getRoutePath("private.geoAdmin.cities"),
      areas: () => getRoutePath("private.geoAdmin.areas"),
      neighbourhoods: () => getRoutePath("private.geoAdmin.neighbourhoods"),
    },
    venueLocations: {
      list: () => getRoutePath("private.venueLocations.list"),
      detail: (locationId) => getRoutePath("private.venueLocations.detail", { locationId }),
    },
    booking: {
      list: () => getRoutePath("private.booking.list"),
      create: () => getRoutePath("private.booking.create"),
      edit: (bookingId) => getRoutePath("private.booking.edit", { bookingId }),
    },
    amenity: {
      list: () => getRoutePath("private.amenity.list"),
      create: () => getRoutePath("private.amenity.create"),
      edit: (amenityId) => getRoutePath("private.amenity.edit", { amenityId }),
    },
    barPreference: {
      list: () => getRoutePath("private.barPreference.list"),
      create: () => getRoutePath("private.barPreference.create"),
      edit: (barPreferenceId) =>
        getRoutePath("private.barPreference.edit", { barPreferenceId }),
    },
    category: {
      list: () => getRoutePath("private.category.list"),
      create: () => getRoutePath("private.category.create"),
      edit: (categoryId) =>
        getRoutePath("private.category.edit", { categoryId }),
    },
    trend: {
      list: () => getRoutePath("private.trend.list"),
      create: () => getRoutePath("private.trend.create"),
      edit: (trendId) => getRoutePath("private.trend.edit", { trendId }),
    },
    cuisine: {
      list: () => getRoutePath("private.cuisine.list"),
      create: () => getRoutePath("private.cuisine.create"),
      edit: (cuisineId) => getRoutePath("private.cuisine.edit", { cuisineId }),
    },
    dietaryPreference: {
      list: () => getRoutePath('private.dietaryPreference.list'),
      create: () => getRoutePath('private.dietaryPreference.create'),
      edit: (dietaryPreferenceId) => getRoutePath('private.dietaryPreference.edit', { dietaryPreferenceId })
    },
    occasion: {
      list: () => getRoutePath('private.occasion.list'),
      create: () => getRoutePath('private.occasion.create'),
      edit: (occasionId) => getRoutePath('private.occasion.edit', { occasionId })
    },
    user: {
      list: () => getRoutePath('private.user.list'),
      create: () => getRoutePath('private.user.create'),
      edit: (userId) => getRoutePath('private.user.edit', { userId })
    },
    item: {
      list: () => getRoutePath('private.item.list'),
      create: () => getRoutePath('private.item.create'),
      edit: (itemId) => getRoutePath('private.item.edit', { itemId })
    },
    post: {
      list: () => getRoutePath('private.post.list'),
      create: () => getRoutePath('private.post.create'),
      edit: (postId) => getRoutePath('private.post.edit', { postId })
    },
    thread: {
      list: () => getRoutePath('private.thread.list'),
      create: () => getRoutePath('private.thread.create'),
      edit: (threadId) => getRoutePath('private.thread.edit', { threadId })
    },
    activity: {
      list: () => getRoutePath('private.activity.list'),
      create: () => getRoutePath('private.activity.create'),
      edit: (activityId) => getRoutePath('private.activity.edit', { activityId })
    },
    keywordCategory: {
      list: () => getRoutePath('private.keywordCategory.list'),
      create: () => getRoutePath('private.keywordCategory.create'),
      edit: (keywordCategoryId) => getRoutePath('private.keywordCategory.edit', { keywordCategoryId })
    },
    businessKeywordsCategories: {
      list: () => getRoutePath('private.businessKeywordsCategories.list'),
      create: () => getRoutePath('private.businessKeywordsCategories.create'),
      edit: (id) => getRoutePath('private.businessKeywordsCategories.edit', { id })
    },
  },
};
